/**
 * Generated runtime TestId mirror for frontend/src/pages/LlmPromptDetail.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const LlmPromptDetailTestIds = {
  btnCancelPrompt: "btn-cancel-prompt",
  btnRenderPreview: "btn-render-preview",
  btnRestoreDefault: "btn-restore-default",
  btnSavePrompt: "btn-save-prompt",
  btnSendToLlm: "btn-send-to-llm",
  btnToggleTestPanel: "btn-toggle-test-panel",
  cardLlmPromptMetadata: "card-llm-prompt-metadata",
  cardTitlePromptEditor: "card-title-prompt-editor",
  cardTitleTestPanel: "card-title-test-panel",
  dialogRestoreDefault: "dialog-restore-default",
  inputTestRequest: "input-test-request",
  llmPromptDetailPage: "llm-prompt-detail-page",
  llmPromptEditor: "llm-prompt-editor",
  llmPromptTextarea: "llm-prompt-textarea",
  llmPromptVariables: "llm-prompt-variables",
  llmTestResponse: "llm-test-response",
  renderedPromptPreview: "rendered-prompt-preview"
} as const;
